<template>
    <error-screen
        :error-code="AppErrorCode.FATAL_ERROR"
    />
</template>

<script setup lang="ts">
    import { AppErrorCode } from "@ca.vmedia.tv/domains";
</script>
